import React from 'react';
import { useStoreState } from "easy-peasy";

class AdobeScript extends React.Component {

    constructor() {
        super();
        this.Setting = useStoreState((state) => state.siteSettingsModel);
    }

    setup = () => {
        let adobeScript = document.createElement('script');
        let enviroment = (process.env.REACT_APP_CFC_APPLICANT_BUILDENV !== "PRODUCTION") ? '4a2f4efaa20b-development' : '59f28510c494'
       
        adobeScript.setAttribute('src','https://assets.adobedtm.com/9d15584567ef/86d49d560da9/launch-'+ enviroment +'.min.js');
        adobeScript.setAttribute('async', "");
        document.head.appendChild(adobeScript);
        console.log("Adobe Service Loaded!")
        return this
    }
}

export default AdobeScript